/**
 * Clerk env-gating helpers.
 *
 * The SPA only mounts `<ClerkProvider>` when `VITE_CLERK_PUBLISHABLE_KEY`
 * is set on the build (Cloudflare Pages env var). Without the key, the
 * SPA falls back to the dev-shim auth from Stream A — this is what the
 * preview deploys use today.
 *
 * Stream C of Phase 14 sets the key on the production Pages env, flips
 * Fly's `RUNTIME` to `prod`, and the same code path activates Clerk
 * automatically.
 */

export const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;

export const hasClerk = Boolean(clerkPublishableKey);
